<template>
  <div id="examineRecommend">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends管理-查看-推荐会员清单</h1>
      </div>

      <div class="header-button">
        <el-button class="push-button" icon="iconfont icon-fanhui" plain @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="flex-between">
      <div class="header-center flex-between">
        <div class="tabs" style="width: 1208px; margin-top: 10px">
          <el-card shadow="never" style="height: 80vh">
            <div style="margin-bottom: 10px">
              <span style="color: #a19b5a; font-weight: 700">推荐会员清单</span>
            </div>
            <!-- 表格 -->
            <div>
              <el-table
                size="small"
                class="table-style"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="560px"
                v-el-table-infinite-scroll="load"
                v-loading="loading"
                infinite-scroll-disabled="onLoading"
              >
                <el-table-column type="index" width="45"></el-table-column>
                <el-table-column prop="cardNo" label="会员卡号" width="150"></el-table-column>
                <el-table-column prop="custName" label="姓名"></el-table-column>
                <el-table-column prop="shopName" label="当前维护店" width="150"></el-table-column>
                <el-table-column prop="empName" label="品牌顾问"></el-table-column>
                <el-table-column prop="saleAAmount" label="购买金额合计"></el-table-column>
                <el-table-column prop="saleAQty" label="购买数量合计"></el-table-column>
                <el-table-column prop="currYearAmount" label="今年消费金额"></el-table-column>
                <el-table-column prop="currYearSaleTimes" label="今年消费次数"></el-table-column>
                <el-table-column prop="accompanySaleMoney" label="陪同消费金额">
                  <template
                    slot-scope="scope"
                  >{{scope.row.accompanySaleMoney?scope.row.accompanySaleMoney:'0'}}</template>
                </el-table-column>
                <el-table-column prop="accompanySaleNum" label="陪同消费次数"></el-table-column>
                <el-table-column prop="name" width="150" label="创建时间">
                  <template slot-scope="scope">{{ scope.row.createTime | dateFormat }}</template>
                </el-table-column>
              </el-table>
              <el-alert
                v-if="total<=tableData.length"
                title="没有更多数据了!"
                type="warning"
                center
                :closable="false"
              ></el-alert>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div style="margin-top: 10px; margin-left: 30px">
          <Rightcards :GFCrmID="queryInfo.GFCrmID"></Rightcards>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReferCustPage } from "@/api/friends";
export default {
  name: "centre",
  components: {},
  data() {
    return {
      activeName: "first",
      labelPosition: "top",

      tableData: [],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formInline: {
        user: "",
        region: ""
      },
      queryInfo: {
        GFCrmID: this.$route.query.custID,
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      size: 0,
      pageSize: 0,
      loading: false
    };
  },
  created() {
    this.loading = true;
    this.getTableData();
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    }
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.getTableData();
        }
      }, 1000);
    },
    //获取列表数据
    getTableData() {
      this.loading = true;
      getReferCustPage(this.queryInfo).then(res => {
        console.log(res);
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        this.size = res.data.size;
        this.pageSize = res.data.pageSize;
        this.loading = false;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      // this.$router.go(-1); //返回上一层

      this.$router.push({
        path: "/Examine",
        query: {
          custID: this.$route.query.custID
        }
      }); //返回GF管理查看
    }
  }
};
</script>
<style lang="scss" scoped>
#examineRecommend {
}
.header {
  .header-text {
    width: 400px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}

.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  height: 30px;
  border-radius: 0 !important;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
}
</style>
